import { ComputedProductStatus, InventoryByLotStatus, InventoryStatus } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

// Controls visibility of UI elements for actions not yet implemented
export const SHOULD_SHOW_UNIMPLEMENTED = false

export const PRODUCT_STATUS_OPTIONS: Option<ComputedProductStatus>[] = [
  { value: ComputedProductStatus.Active, label: "Active" },
  { value: ComputedProductStatus.Inactive, label: "Inactive" },
]

export const INVENTORY_STATUS_TO_LABEL: Record<InventoryStatus, string> = {
  [InventoryStatus.Good]: "Good",
  [InventoryStatus.Low]: "Low",
  [InventoryStatus.Out]: "Out",
  [InventoryStatus.OnHold]: "On Hold",
} as const

export const INVENTORY_STATUS_OPTIONS: Option<InventoryStatus>[] = Object.values(InventoryStatus).map((status) => ({
  value: status,
  label: INVENTORY_STATUS_TO_LABEL[status],
}))

export const ALL_WAREHOUSES_VALUE = "ALL"

export const ALL_WAREHOUSES_OPTION: Option<string> = { value: ALL_WAREHOUSES_VALUE, label: "All Warehouses" }

export const INVENTORY_LOT_STATUS_TO_LABEL: Record<InventoryByLotStatus, string> = {
  [InventoryByLotStatus.Approved]: "Approved",
  [InventoryByLotStatus.DirectShip]: "Direct Ship",
  [InventoryByLotStatus.NotEvaluated]: "Not Evaluated",
  [InventoryByLotStatus.OnHold]: "On Hold",
  [InventoryByLotStatus.Rejected]: "Rejected",
} as const
